import React, { useEffect, useRef, useState } from "react";
import { Modal, Nav, Tab } from "react-bootstrap";
import modelImg from "../../Assets/remove.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const ModalComponent = ({
  show,
  handleClose,
  productDetails,
  activeTab,
  modalClass,
}) => {
  const translation = getTranslationData();
  const instrRef = useRef(null);
  const howToRef = useRef(null);
  const [sectionHeight, setSectionHeight] = useState("auto");
  const [isMobile, setIsMobile] = useState(false);

  // detect mobile layout
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // function to measure HTML content height (used only on mobile)
  const measureContentHeight = (html) => {
    if (!html) return 0;
    const temp = document.createElement("div");
    temp.innerHTML = html;
    temp.className = "temp-measure";
    document.body.appendChild(temp);
    const height = temp.scrollHeight;
    document.body.removeChild(temp);
    return height;
  };

  // dynamic height calculation (only for mobile view)
  useEffect(() => {
    if (!productDetails || !show || !isMobile) {
      setSectionHeight("auto"); // reset to auto for desktop/tablet
      return;
    }

    const instrContent =
      productDetails?.productReducer?.instructionsContent || "";
    const howToContent = productDetails?.productReducer?.howToUseContent || "";

    const instrHeight = measureContentHeight(instrContent);
    const howToHeight = measureContentHeight(howToContent);

    const longerHeight = Math.max(instrHeight, howToHeight);

    const MIN_HEIGHT = 100; // ~2 lines
    const MAX_HEIGHT = 400; // ~8 lines

    const finalHeight = Math.min(
      Math.max(longerHeight, MIN_HEIGHT),
      MAX_HEIGHT
    );

    setSectionHeight(`${finalHeight}px`);
  }, [productDetails, show, isMobile, activeTab]);

  const renderInstructionHtmlContent = () => ({
    __html: productDetails?.productReducer?.instructionsContent,
  });

  const renderHowToUseHtmlContent = () => ({
    __html: productDetails?.productReducer?.howToUseContent,
  });

  const renderTermsConHtmlContent = () => ({
    __html: productDetails?.productReducer?.tncContent,
  });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="exampleModalLabel"
      centered
      dialogClassName={`${modalClass}`}
    >
      <div className={`modal-header-custom justify-content-center p-1 ${modalClass}`}>
        <button
          type="button"
          className="modal-btn"
          aria-label="Close"
          onClick={handleClose}
        >
          <img className="w-35px" src={modelImg} alt="Close" />
        </button>
      </div>

      <Modal.Body className="modal-body pt-0 mt-4 p-4">
        {activeTab === "terms" ? (
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab}>
            <Nav variant="tabs" className="custom-nav-terms mb-3">
              <Nav.Item>
                <Nav.Link eventKey="terms">
                  {translation?.terms_condition}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="list-pad">
              <Tab.Pane eventKey="terms">
                <div
                  className="list-bullet"
                  style={{
            overflowWrap: "break-word",
          }}
                  dangerouslySetInnerHTML={renderTermsConHtmlContent()}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        ) : (
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab}>
            <Nav variant="tabs" className="custom-nav mb-3">
              <Nav.Item>
                <Nav.Link eventKey="instr" className="left-tab">
                  {translation?.importantInstructions}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="redeem" className="right-tab">
                  {translation?.how_to_use}
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="howToUse list-pad">
              <Tab.Pane eventKey="instr">
                <div
                  ref={instrRef}
                  className={`tab-content-scroll ${isMobile ? "mobile-scroll" : ""
                    }`}
                  style={{
                    height: sectionHeight,
                    overflowY:
                      isMobile && parseInt(sectionHeight) >= 400
                        ? "auto"
                        : "visible",
                    transition: isMobile ? "height 0.3s ease" : "none",
                  }}
                  dangerouslySetInnerHTML={renderInstructionHtmlContent()}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="redeem">
                <div
                  ref={howToRef}
                  className={`tab-content-scroll ${isMobile ? "mobile-scroll" : ""
                    }`}
                  style={{
                    height: sectionHeight,
                    overflowY:
                      isMobile && parseInt(sectionHeight) >= 400
                        ? "auto"
                        : "visible",
                    transition: isMobile ? "height 0.3s ease" : "none",
                  }}
                  dangerouslySetInnerHTML={renderHowToUseHtmlContent()}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
